import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { PlusOrange } from "../../../../ui/icons/plusOrange";
import { TrashIcon } from "../../../../ui/icons/trash";
import { ButtonComponent } from "../../../../ui/molecules/button/newButton";
import { MadfarmInput } from "../../../../ui/molecules/input/newInput";
import { addCustomerOtherOdcDefault, addCustomerOtherOdcDefaultEdit, setClientCodeOtherOdcCreation, setClientCodeOtherOdcUpdate, setCompanyNameOtherOdcCreation, setCompanyNameOtherOdcUpdate, setCreationCustomerOtherOdcDefault, setCuaaOtherOdcCreation, setCuaaOtherOdcUpdate, setEditCustomerOtherOdcDefault } from "../slice";

export function CustomersOtherOdCAdd() {
    const dispatch = useAppDispatch()
    const complianceRequestState = useAppSelector(state => state.complianceRequest)

    return (
        <div className="flex flex-col gap-4">
            <div className='pt-5 grid grid-cols-1 md:grid-cols-2 gap-6 items-center'>
                <div className="text-left">
                    <span className="text-sm font-semibold uppercase tracking-widest text-brandPrimary-600">Clienti altro Odc</span>
                </div>
                <div className="flex justify-start md:justify-end">
                    <ButtonComponent
                        size='sm'
                        color='orange'
                        variant='outline'
                        label='Aggiungi Cliente altro OdC'
                        iconPosition='right'
                        onClick={() => {
                            dispatch(addCustomerOtherOdcDefault())
                            // dispatch(addCustomerOtherOdc())
                        }}
                        icon={<PlusOrange color='orange' size={20} />}
                    />
                </div>
            </div>
            {complianceRequestState.complianceRequestsCreation.otherOdcCustomer.map((singleCustomer, index) => (
                <div
                    key={`add-other-odc-${index}`}
                    className='grid grid-cols-1 md:grid-cols-12 gap-3 items-end'>
                    <div className="md:col-span-4">
                        <MadfarmInput
                            // error={}
                            // supportingText={}
                            label={'Ragione Sociale'}
                            placeholder="Ragione Sociale"
                            value={complianceRequestState.complianceRequestsCreation.otherOdcCustomer[index].companyName}
                            defaultValue={complianceRequestState.complianceRequestsCreation.otherOdcCustomer[index].companyName}
                            onChangeText={(text) => { dispatch(setCompanyNameOtherOdcCreation({ data: text, index: index })) }}
                        />
                    </div>
                    <div className="md:col-span-4">
                        <MadfarmInput
                            label={'CUAA'}
                            placeholder="CUAA"
                            onChangeText={(text) => { dispatch(setCuaaOtherOdcCreation({ data: text, index: index })) }}
                            value={complianceRequestState.complianceRequestsCreation.otherOdcCustomer[index].cuaa}
                            defaultValue={complianceRequestState.complianceRequestsCreation.otherOdcCustomer[index].cuaa}
                        />
                    </div>
                    <div className="md:col-span-3">
                        <MadfarmInput

                            label={'Codice'}
                            placeholder="Codice"
                            onChangeText={(text) => { dispatch(setClientCodeOtherOdcCreation({ data: text, index: index })) }}
                            value={complianceRequestState.complianceRequestsCreation.otherOdcCustomer[index].clientCode}
                            defaultValue={complianceRequestState.complianceRequestsCreation.otherOdcCustomer[index].clientCode}
                        />
                    </div>
                    <div className="md:col-span-1 flex justify-end md:justify-center pb-1">
                        <ButtonComponent
                            size='lg'
                            iconPosition='only'
                            icon={<TrashIcon color='#f00' size={20} />}
                            variant='outline'
                            color='orange'
                            onClick={() => {
                                const newActivities = complianceRequestState.complianceRequestsCreation.otherOdcCustomer.filter((_, idx) => idx !== index)
                                dispatch(setCreationCustomerOtherOdcDefault(newActivities))
                            }}
                        />
                    </div>
                </div>
            ))}
        </div>
    )
}

export function CustomersOtherOdCEdit() {
    const dispatch = useAppDispatch()
    const complianceRequestState = useAppSelector(state => state.complianceRequest)

    return (
        <div className="pb-5 border-b border-neutral-200">
            <div className='pt-5 grid grid-cols-1 md:grid-cols-2 gap-6 items-center'>
                <div className="text-left">
                    <span className="subtitle">Clienti altro OdC</span>
                </div>
                <div className="flex justify-start md:justify-end">
                    <ButtonComponent
                        size='sm'
                        color='orange'
                        variant='outline'
                        label='Aggiungi cliente altro OdC'
                        iconPosition='right'
                        onClick={() => {
                            dispatch(addCustomerOtherOdcDefaultEdit())
                        }}
                        icon={<PlusOrange color='orange' size={20} />} />
                </div>
            </div>
            {
                complianceRequestState.complianceRequestsUpdate.otherOdcCustomer?.map((singleCustomer, index) => (
                    <div key={`edit-other-odc-${index}`} className='pt-5 grid grid-cols-1 md:grid-cols-12 gap-6 items-end'>
                        <div className="md:col-span-4">
                            <MadfarmInput
                                // error={}
                                // supportingText={}
                                label={'Ragione Sociale'}
                                placeholder="Ragione Sociale"
                                value={complianceRequestState.complianceRequestsUpdate.otherOdcCustomer[index].companyName}
                                defaultValue={complianceRequestState.complianceRequestsUpdate.otherOdcCustomer[index].companyName}
                                onChangeText={(text) => { dispatch(setCompanyNameOtherOdcUpdate({ data: text, index: index })) }}
                            />
                        </div>
                        <div className="md:col-span-4">
                            <MadfarmInput
                                // error={}
                                // supportingText={}
                                label={'CUAA'}
                                placeholder="CUAA"
                                value={complianceRequestState.complianceRequestsUpdate.otherOdcCustomer[index].cuaa}
                                defaultValue={complianceRequestState.complianceRequestsUpdate.otherOdcCustomer[index].cuaa}
                                onChangeText={(text) => { dispatch(setCuaaOtherOdcUpdate({ data: text, index: index })) }}
                            />
                        </div>
                        <div className="md:col-span-3">
                            <MadfarmInput
                                label={'Codice'}
                                placeholder="Codice"
                                value={complianceRequestState.complianceRequestsUpdate.otherOdcCustomer[index].clientCode}
                                defaultValue={complianceRequestState.complianceRequestsUpdate.otherOdcCustomer[index].clientCode}
                                onChangeText={(text) => { dispatch(setClientCodeOtherOdcUpdate({ data: text, index: index })) }}
                            />
                        </div>
                        <div className="md:col-span-1 flex justify-end md:justify-center pb-1">
                            <ButtonComponent
                                size='md'
                                iconPosition='only'
                                icon={<TrashIcon color='#f00' size={20} />}
                                variant='outline'
                                color='orange'
                                onClick={() => {
                                    const newActivities = complianceRequestState.complianceRequestsUpdate.otherOdcCustomer.filter((_, idx) => idx !== index)
                                    dispatch(setEditCustomerOtherOdcDefault(newActivities))
                                }}
                            />
                        </div>
                    </div>
                ))
            }
        </div>
    )
}